import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type Sentiment = 'Positive' | 'Neutral' | 'Negative';

// Ported from the sentiment pill in the Overview story modal - same colors used for the
// Sentiment Tone picker in FilterBar and reused again on the future Sentiment screen, so it's a
// shared component rather than something redefined per screen.
@Component({
	selector: 'app-sentiment-badge',
	standalone: true,
	imports: [],
	templateUrl: './sentiment-badge.component.html',
	styleUrl: './sentiment-badge.component.scss',
})
export class SentimentBadgeComponent {
	@Input({ required: true }) sentiment!: Sentiment;

	constructor(private readonly translate: TranslateService) {}

	// SETTE redesign (CLIPPING-598): "+ Positive" / "○ Neutral" / "− Negative" - color never
	// alone (Принцип 2), so the sign glyph is baked into the label itself (U+2212 for the
	// minus, never an ASCII hyphen). Фаза 6: the word itself reuses CLIPS.SENTIMENT_RATING_TYPE,
	// the same key the clip-rating UI already translates, instead of a second Analytics-only copy.
	get label(): string {
		switch (this.sentiment) {
			case 'Positive':
				return `+ ${this.translate.instant('CLIPS.SENTIMENT_RATING_TYPE.POSITIVE')}`;
			case 'Negative':
				return `− ${this.translate.instant('CLIPS.SENTIMENT_RATING_TYPE.NEGATIVE')}`;
			default:
				return `○ ${this.translate.instant('CLIPS.SENTIMENT_RATING_TYPE.NEUTRAL')}`;
		}
	}

	get classes(): string {
		switch (this.sentiment) {
			case 'Positive':
				return 'bg-positive-tint text-positive';
			case 'Negative':
				return 'bg-negative-tint text-negative';
			default:
				return 'bg-neutral-tint text-ink-subtle';
		}
	}
}
